import { TAB_MINE } from "/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/index.tsx?tsr-shared=1";
const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/index.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/resources/exercises/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { listCatalogExercisesQuery } from '@/features/workouts/lib/list-catalog-exercises.query';
const DEFAULT_CATALOG_QUERY = '';
const exercisesSearchSchema = z.object({
  tab: z.literal(TAB_MINE).optional().catch(undefined)
});
export const Route = createFileRoute('/_authenticated/resources/exercises/')({
  validateSearch: exercisesSearchSchema,
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await Promise.all([context.queryClient.ensureInfiniteQueryData(listCatalogExercisesQuery(deps, 'system', DEFAULT_CATALOG_QUERY)), context.queryClient.ensureInfiniteQueryData(listCatalogExercisesQuery(deps, 'custom', DEFAULT_CATALOG_QUERY))]);
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});